exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n#app > .l-footer {\n    height: 32px;\n    padding: 0 10px;\n    background: #333333;\n}\n#app > .l-footer a:before {\n    content: '\\25B6';\n    margin-right: 5px;\n}\n\n", ""]);
